<template>
  <b-modal
    no-close-on-backdrop
    centered
    ok-only
    size="md"
    ok-title="Fechar"
    ok-variant="danger"
    v-model="open"
    title="Adicionar/Editar NF do Pedido"
    :busy="loading"
  >
    <b-row v-if="loading">
      <b-col cols="12" class="text-center">
        <b-spinner label="Spinning"></b-spinner>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col cols="12" class=" text-center">
        <span class="font-weight-bold fs-18">Pedido nº {{ order.uuid }} - </span>
        <span class="font-weight-bold fs-18">Valor {{ formatNumber(order.totalValue) }}</span>
      </b-col>
      
      <b-col cols="12" class="mt-2 mb-3">
        <label>Número da Nota Fiscal: {{ numberInvoice }}</label>
       <b-input 
        v-model="numberInvoice"
        v-mask="['#########']"
      />
      </b-col>
      <b-col cols="6" class="">
        <b-button variant="outline-danger" block @click="deleteInvoice()">
          <i class="fas fa-trash mr-2"/> Excluir
        </b-button>
      </b-col>
      
      <b-col cols="6">
        <b-button variant="success" block @click="save()">
          <i class="fas fa-save mr-2" /> Salvar
        </b-button>
      </b-col>
     
    </b-row>
  </b-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import makeToast from '@/mixins/makeToast';

import Info from '../Inputs/Info.vue';

export default {
  name: 'InvoiceOrder',
  mixins: [makeToast],
  emits: ['getAll'],

  data() {
    return {
      loading: false,
      order: [],
      open: false,
      numberInvoice: null
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
  },
  methods: {
    ...mapActions('shopkeeper', ['saveInvoiceOrder', 'deleteInvoiceOrder']),

    toggleOpen({ order = [] }) {
      this.open = !this.open;
      this.order = order;
      this.numberInvoice = order.invoiceNumber;
      this.loading = false;
    },
    formatNumber(number) {
      const handleNumber = number || 0;

      return Intl.NumberFormat('pt-BR', {
        currency: 'BRL',
        style: 'currency',
      }).format(handleNumber);
    },
    save() {
      if (!this.numberInvoice) {
        this.makeToast(
          'Erro',
          'O número da NF é obrigatório',
          'danger'
        );  
      }

      this.loading = true;

      this.saveInvoiceOrder({
        orderId: this.order.id,
        construpUserId: this.dadosUsuario.id,
        invoice: this.numberInvoice
      })
        .then((response) => {

          if(!response.data.data.result){
            this.makeToast(
              'Erro',
              'Houve um erro ao salvar o número da NF',
              'danger'
            );  
          } else {
            this.makeToast(
              'Sucesso',
              'Número da NF adicionado com sucesso',
              'success'
            );
            this.$emit('getAll')
          }
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao salvar o número da NF',
            'danger'
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },

    deleteInvoice() {
      if (this.loading || !this.numberInvoice) return;

      this.loading = true;

      this.deleteInvoiceOrder({
        orderId: this.order.id,
        construpUserId: this.dadosUsuario.id,
      })
        .then((response) => {
          if(!response.data.data.result){
            this.makeToast(
              'Erro',
              'Houve um erro ao deletar o número da NF, tente novamente',
              'danger'
            );  
          } else {
            this.makeToast(
              'Sucesso',
              'Número da NF removida com sucesso',
              'success'
            );
            this.numberInvoice = null
            this.$emit('getAll');
          }
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao salvar o número da NF',
            'danger'
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
